import { AccessClient } from "./axiosInstance.js";
import { encrypt } from "../util/crypto.js";

// 로그인
export const loadAllUsers = async () => {
  try {
    const response = await AccessClient.get("/api/users");
    const {
      status,
      data: { users },
    } = response;
    return { status, users };
  } catch (error) {
    if (error.response) {
      const {
        status,
        data: { message },
      } = error.response;
      return { status, message };
    }
    throw error;
  }
};

/**
 * 사용자 정보 갱신하기
 * @param {*} param0 
 * @returns 
 */
export const updateUser = async ({
  id, // user id
  roles, // 역활이 배열
  dsUnivLink,
  password,
  new_password,
  new_password2,
}) => {

  const enc_password = password ? encrypt(password) : null;
  const enc_new_password = new_password ? encrypt(new_password) : null;
  const enc_new_password2 = new_password2 ? encrypt(new_password2) : null;

  let body = {
    roles,
    dsUnivLink, // 학사 시스템 연동
    password: enc_password,
    new_password: enc_new_password,
    new_password2: enc_new_password2,
  };

  try {
    const response = await AccessClient.put(`/api/users/${id}`, body);
    console.log("response : ", response);
    const {
      status,
      data: { message },
    } = response;
    return { status, message };
  } catch (error) {
    //    console.log(error.response);

    const {
      status,
      data: { message },
    } = error.response;
    return { status, message };
  }
};


